import { render, staticRenderFns } from "./ControlsContainer.vue?vue&type=template&id=25255d95&scoped=true&"
import script from "./ControlsContainer.vue?vue&type=script&lang=js&"
export * from "./ControlsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ControlsContainer.vue?vue&type=style&index=0&id=25255d95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25255d95",
  null
  
)

export default component.exports